/**
 * `console.log` in development builds only. The data adapters trace every
 * fetch; in production that is noise on each poll and each map click.
 * Warnings and errors still use `console.warn` / `console.error`.
 */
export const devLog: (...args: unknown[]) => void = process.env.NODE_ENV === "development" ? console.log.bind(console) : () => undefined;
